<template>
  <v-btn
    class="pa-0 toolbar-button"
    color="primary"
    variant="text"
    size="x-small"
    :height="24"
    :min-width="24"
    v-bind="{ ...$props, ...$attrs }"
  >
    <DpplSvg
      class="icon"
      :file-name="`icons/${iconName}`"
    />
    <slot name="after" />
  </v-btn>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

export default {
  name: 'ToolbarButton',
  components: { DpplSvg },
  props: {
    iconName: { type: String, default: '' },
  },
};
</script>

<style lang="less" scoped>
.toolbar-button {
  border-radius: 4px;

  &:disabled {
    opacity: 0.5;
  }

  .icon {
    height: 12px;
    fill: @icon-darkest;
  }

  &.v-btn--active {
    background: @bg-canvas;
    .icon {
      fill: @icon-brand;
    }

    .v-btn__overlay {
      display: none;
    }
  }
}
</style>
